// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
// custom components
import NumberedHeading from "../../../../../shared-components/forms/NumberedHeading";
import WYSIWYGEditor from "../../../../../shared-components/WYSIWYGEditor";
import EmentorArray from '../shared/EmentorArray';
import NoteCardArray from './components/NoteCardArray';

const NoteCards = (props) => {

  const { control, formState } = props.methods;
  const { errors } = formState;

  const { inputDir } = props;

  return (
    <div>
      <NumberedHeading number="1" title="Context Instruction (TL)" instructions="What is the Context Instruction (TL)?" />
      <Controller
        control={control}
        name="content.context_tl"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.context_tl} />}
      />

      <Divider className="my-16" />
      <NumberedHeading number="1" title="Context Instruction (EN)" instructions="What is the Context Instruction (EN)?" />
      <Controller
        control={control}
        name="content.context_en"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.context_en} />}
      />

      <Divider className="my-16" />
      <NumberedHeading number="1" title="Prompt (TL)" instructions="What is the Prompt (TL)?" />
      <Controller
        control={control}
        name="content.prompt"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.prompt} />}
      />

      <Divider className="my-16" />
      <NumberedHeading number="1" title="Cards" instructions="Use the following controls to add cards as necessary." />
      <Controller
        control={control}
        name="content.cards"
        render={({ field }) => <NoteCardArray inputDir={inputDir} {...{control, errors }} />}
      />

      <Divider className="my-16" />
      <NumberedHeading number="3" title="eMentor Notes" instructions="Using the controls below, add any supplemental content to this page" />
      <Controller
        control={control}
        name="content.eMentor"
        render={({ field }) => <EmentorArray {...{ control, errors }} />}
      />
    </div>
  );
};

export default NoteCards;